/** @jsxImportSource @emotion/react */
"use client";

import type { Interpolation } from "@emotion/react";
import { Link } from "@i18n/next";
import { ExportIcon, radius, spacing, Text } from "@packages/ui";

const baseStyles: Interpolation = {
  alignItems: "center",
  border: `2px solid var(--sc-neutrals-lowest)`,
  borderRadius: radius.m,
  cursor: "pointer",
  display: "flex",
  gap: spacing.l,
  justifyContent: "space-between",
  padding: `${spacing.m} ${spacing.l}`,
  "&:hover": {
    background: "var(--sc-neutrals-lowest)",
  },
};

interface LegalOptionProps {
  label: string;
  href: string;
}

const LegalOption = ({ label, href }: LegalOptionProps) => {
  return (
    <Link css={baseStyles} href={href} target="_blank">
      <Text size="m" type="title">
        {label}
      </Text>
      <ExportIcon />
    </Link>
  );
};

export default LegalOption;
